import createAdminRepository from '~/api/admin/RepositoryFactory'
import createFrontendRepository from '~/api/frontend/RepositoryFactory'

export default ({$axios}, inject) => {
  inject('adminRepositories', createAdminRepository($axios));
  inject('frontendRepositories', createFrontendRepository($axios));
}
